import { steps } from "./steps";
import { components } from "./components";

export const fiscalProfileForm = {
	components,
	steps,
	titleSteps: {
		company: "Datos de la empresa",
		fiscal: "Datos fiscales",
		general: "Datos generales",
		tip: "Configuración de propina",
	},
	navigateBackLabel: "Volver a perfiles fiscales",
};
